import { connect } from 'react-redux';
import { Dispatch, AnyAction } from 'redux';
import RootState from '../../modules/rootState';
import Summary, { StateFromProps, DispatchFromProps } from './Summary';
import * as workflowData from 'src/modules/entities/workflow';
import * as providerData from 'src/modules/entities/provider';

const mapStateToProps = (rootState: RootState): StateFromProps => ({
    registrationId: workflowData.selectors.getRegistrationId(rootState),
    loading: providerData.selectors.loading(rootState),

    provider: providerData.selectors.getProviderInfoSummary(rootState),
    submitting: providerData.selectors.submitting(rootState),
    submitted: providerData.selectors.submitted(rootState)
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): DispatchFromProps => ({
    getProviderById: (id: string): void => {
        dispatch(providerData.actions.getProviderInfoAsync(id));
    },
    submitToVendor: (registrationId: string): void => {
        dispatch(providerData.actions.submitToVendorAsync(registrationId));
    },
    resetSubmitStatus: (): void => {
        dispatch(providerData.actions.resetSubmitStatus());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Summary);


// WEBPACK FOOTER //
// ./src/components/Summary/Summary.container.ts